/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var CSSTransition = require("react-transition-group/CSSTransition");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./VerticalHeader.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var OutsideClick_1 = require("./util/OutsideClick");
var metroUnitedSvg = require("../img/metro/employeefacing/metro-united-small-inverted.svg");
var metroSvg = require("../img/metro/employeefacing/brand-small-metro.svg");
var makroSvg = require("../img/metro/employeefacing/brand-small-makro.svg");
var makroNlSvg = require("../img/metro/employeefacing/brand-small-makro-nl.svg");
var StoreID_1 = require("./StoreID");
var Spinner_1 = require("./Spinner");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-verticalHeader");
var logoSources = {
    "metro-united": metroUnitedSvg,
    metro: metroSvg,
    makro: makroSvg,
    "makro-nl": makroNlSvg
};
var VerticalHeader = /** @class */ (function (_super) {
    tslib_1.__extends(VerticalHeader, _super);
    function VerticalHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalHeader.prototype.renderHead = function () {
        var _a = this.props, logoVariant = _a.logoVariant, logoLinkProps = _a.logoLinkProps;
        return (React.createElement("a", tslib_1.__assign({ href: "#" }, logoLinkProps, { className: moduleClassName("head") }),
            React.createElement("img", { src: logoSources[logoVariant], className: moduleClassName("logo") })));
    };
    VerticalHeader.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (React.createElement("div", { className: classnames(moduleClassName(), className) },
            this.renderHead(),
            React.createElement("div", { className: moduleClassName("nav") }, children)));
    };
    VerticalHeader.propTypes = {
        className: PropTypes.string,
        logoLinkProps: PropTypes.object,
        logoVariant: PropTypes.oneOf(Object.keys(logoSources))
    };
    VerticalHeader.defaultProps = {
        logoLinkProps: {}
    };
    return VerticalHeader;
}(React.Component));
exports.VerticalHeader = VerticalHeader;
exports.VerticalHeaderButton = function VerticalHeaderButton(props) {
    // eslint-disable-line react/no-multi-comp
    var iconType = props.iconType, children = props.children, onClick = props.onClick, active = props.active, push = props.push, largeIcon = props.largeIcon, storeId = props.storeId, waiting = props.waiting, htmlTitle = props.htmlTitle;
    return (React.createElement("div", { className: classnames(moduleClassName("button"), !!active && moduleClassName("button-isActive"), !!largeIcon && moduleClassName("button-hasLargeIcon"), !!push && moduleClassName("buttonPush")) },
        waiting ? (React.createElement(Spinner_1.Spinner, { className: moduleClassName("buttonSpinner") })) : (React.createElement("button", { className: classnames(moduleClassName("button"), !!active && moduleClassName("button-isActive"), !!push && moduleClassName("buttonPush")), onClick: onClick, title: htmlTitle },
            React.createElement(Icon_1.Icon, { type: iconType, color: "white" }),
            storeId && (React.createElement(StoreID_1.StoreID, { primary: true, compact: true }, storeId)))),
        !!children && children));
};
exports.VerticalHeaderButton.propTypes = {
    active: PropTypes.bool,
    largeIcon: PropTypes.bool,
    waiting: PropTypes.bool,
    htmlTitle: PropTypes.string,
    storeId: PropTypes.string,
    iconType: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired,
    onClick: PropTypes.func.isRequired,
    push: PropTypes.bool
};
exports.VerticalHeaderDrawer = function VerticalHeaderDrawer(_a // eslint-disable-line react/no-multi-comp
) {
    var active = _a.active, children = _a.children, requestClose = _a.requestClose;
    return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: function () { return active && requestClose(); } },
        React.createElement(CSSTransition, { key: "content", in: active, className: moduleClassName("drawer"), classNames: moduleClassName("drawer"), timeout: 300, mountOnEnter: true, unmountOnExit: true },
            React.createElement("div", null, children))));
};
exports.VerticalHeaderDrawer.propTypes = {
    active: PropTypes.bool,
    requestClose: PropTypes.func.isRequired
};
exports.VerticalHeaderDrawerContent = function VerticalHeaderDrawerContent(_a) {
    var children = _a.children;
    return React.createElement("div", { className: moduleClassName("drawerContent") }, children);
};
exports.VerticalHeaderTooltip = function VerticalHeaderTooltip(_a) {
    var active = _a.active, children = _a.children, requestClose = _a.requestClose;
    return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: function () { return active && requestClose(); } },
        React.createElement(CSSTransition, { key: "content", in: active, className: moduleClassName("tooltip"), classNames: moduleClassName("tooltip"), timeout: 300, mountOnEnter: true, unmountOnExit: true },
            React.createElement("div", null,
                React.createElement("div", { className: moduleClassName("tooltipContent") }, children)))));
};
exports.VerticalHeaderTooltip.propTypes = {
    active: PropTypes.bool,
    requestClose: PropTypes.func.isRequired
};